class NumberFormatter {

    /**
     * Converts a string representing a number in a locale-specific format to a JavaScript number.
     *
     * @param {string|number} numberString - The number string to convert.
     * @return {number} - The converted JavaScript number.
     */
    static numberFromLocaleString(numberString) {
        if (typeof numberString === 'number') {
            return numberString;
        }

        // Handling edge case where string starts with '.' or ','
        if (numberString.startsWith('.') || numberString.startsWith(',')) {
            numberString = '0' + numberString;
        }

        // Determine separator use based on context
        const hasComma = numberString.includes(',');
        const hasPeriod = numberString.includes('.');

        // Differentiating decimal and thousand separators
        if (hasComma && hasPeriod) {
            // European format (e.g., 1.000,00)
            numberString = numberString.replace(/\./g, '').replace(',', '.');
        } else if (hasComma) {
            // Comma as decimal separator
            numberString = numberString.replace(',', '.');
        } else if (hasPeriod && !(/\.\d+$/.test(numberString))) {
            // Only periods, no commas. Check if period is not a decimal separator
            // Period as thousand separator
            numberString = numberString.replace(/\./g, '');
        }

        return parseFloat(numberString);
    }

}

module.exports.NumberFormatter = NumberFormatter;